
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desserts",
      function () {
        return require("private-next-pages/desserts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/desserts"])
      });
    }
  